<template>
<svg width="10" height="10" viewBox="0 0 10 10" :fill="this.color" xmlns="http://www.w3.org/2000/svg">
<path d="M0.791847 10L0 9.20815L4.20815 5L0 0.791847L0.791847 0L5 4.20815L9.20815 0L10 0.791847L5.79185 5L10 9.20815L9.20815 10L5 5.79185L0.791847 10Z" :fill="this.color"/>
</svg>

</template>

<script>
export default {
    props: {
        color: String,
    }
}
</script>


// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/CloseIcon.vue